export default "__VITE_ASSET__FR76gTFC__"